import e from"react";import{components as o}from"react-select";const{Option:r}=o,t=({children:o,innerProps:t,...n})=>e.createElement(r,{...n,innerProps:{...t,title:"string"==typeof o?o:void 0,onMouseMove:()=>({}),onMouseOver:()=>({})}},o);export{t as Option};
//# sourceMappingURL=Option.js.map
